export default __webpack_public_path__ + "static/media/janvier.a536641f.jpg";